/**
 * Lit dev-mode warning suppression.
 *
 * This module MUST be imported as the very first import in App.tsx (or any
 * entry file that uses DS components).
 *
 * Putting these lines directly in App.tsx does NOT work: ES modules hoist
 * all `import` declarations so they execute before any bare statements in
 * the module body, meaning Lit would load first and the suppression would
 * be too late.  A separate module with NO imports guarantees the
 * suppression code runs before any Lit JavaScript loads.
 *
 * ── DS Theme CSS ─────────────────────────────────────────────────────────
 * Design-system token CSS is loaded via CSS `@import` in
 * `/src/styles/index.css` using a RELATIVE FILESYSTEM PATH to the physical
 * `.css` file inside `node_modules/`.  This bypasses the `enhanced-resolve`
 * / `exports`-field issue because relative paths (`../../node_modules/...`)
 * are resolved as direct filesystem lookups — the package `exports` field
 * is only consulted for bare specifiers (`@tuvsud/design-system/...`).
 *
 * Font CSS is loaded via `/src/styles/index.css` from the design system's
 * `dist/theme/fonts.css`, so fonts are emitted as normal static assets
 * instead of being inlined into the main JS bundle.
 *
 * DO NOT put CSS imports in this file — it must have zero imports to
 * ensure the warning suppression runs before any Lit code loads.
 */

// ── Lit dev-mode suppression ──
// This module intentionally has ZERO import declarations.  Any `import`
// would be hoisted and execute before these lines, defeating the purpose
// if that import transitively loads Lit.  DS theme CSS is loaded through
// the CSS pipeline (index.css) instead.
(globalThis as any).litIssuedWarnings ??= new Set();
(globalThis as any).litIssuedWarnings.add('dev-mode');
(globalThis as any).litIssuedWarnings.add('change-in-update');
(globalThis as any).litIssuedWarnings.add('multiple-versions');
